import { ROUTE_MODULE_INSPIRE, ROUTE_MODULE_PLANNING } from '../../../utils/routes';
import { ModuleLinkSection } from './ModuleLinkSection';
import { t } from '../../../utils/resources';

interface MakeItMagicSectionProps {
  onClick: (item?: string) => void;
}

export const MakeItMagicSection = ({ onClick }: MakeItMagicSectionProps) => (
  <div className="submenu" onMouseLeave={() => onClick('')}>
    <ul>
      <ModuleLinkSection
        module={ROUTE_MODULE_INSPIRE}
        permission={'Webframe.Header.MakeItMagic.Inspire'}
        title={t('Menu.Inspire')}
        description={t('Menu.Inspire.Description')}
        onClick={onClick}
      />
      <ModuleLinkSection
        module={ROUTE_MODULE_PLANNING}
        permission={'Webframe.Header.MakeItMagic.Design'}
        title={t('Menu.Design')}
        description={t('Menu.Design.Description')}
        onClick={onClick}
      />
    </ul>
  </div>
);
